import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { PoNotificationService } from '@po-ui/ng-components';
import { environment } from '../../../environments/environment';
import { TokenService } from './token.service';
import jwtDecode from 'jwt-decode';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  username!: string;
  password!: any;
  mfaToken!: any;
  codigoTokenMfa!: any;
  returnGetToken!: any;
  tenant!: string;
  errorMsg!: string;
  baseApiUrl = environment.modaAPI;
  bodyRequest = {
    Tenant: this.tenant,
    Username: this.username,
    Password: this.password,
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    })
  };
  httpOptionsV2 = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': '0b0fdc98-96a7-45d1-a28b-88fde921fdb4'
    })
  };
  redirectUrl: any = '';
  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private poNotification: PoNotificationService,
    private tokenService: TokenService,
    private apiService: ApiService,
  ) { }

  public postLogin(username: string, password: any, tenant: string) {
    this.username = username;
    this.password = password;
    this.tenant = tenant;
    this.baseApiUrl = environment.modaAPI;
    this.bodyRequest.Username = this.username;
    this.bodyRequest.Password = this.password;
    this.bodyRequest.Tenant = this.tenant;
    this.getToken();
  }

  public async getToken() {
    await fetch(this.baseApiUrl + 'authorization/v2/mop-user-token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body: new URLSearchParams({
        'username': this.bodyRequest.Username,
        'password': this.bodyRequest.Password,
        'tenant': this.bodyRequest.Tenant.toLowerCase()
      })
      .toString()
    })
    .then(response => response.json())
    .then(token => {
      if (token.access_token != undefined) {
        this.tokenService.saveTokenV2(token.access_token);
        let decode: any = jwtDecode(token.access_token);
        this.tokenService.saveComponentsAccess(decode.components);
        this.validateUserHasAuthorization();
        this.router.navigate(['/modulo']);
      } else {
        throw new Error(token[0].message);
      }
    })
    .catch(err => {
      this.errorWarning(err);
    })
  }

  public getModulo(item: any) {
    let httpOptionsModulo = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('tokenV2')
      })
    };
    this.httpClient.post(this.baseApiUrl + 'authorization/v2/mop-app-token', {component: item}, httpOptionsModulo).subscribe(
      (data: any) => {
        item !== 'MOPFC004'
        ? this.tokenService.saveToken(data.access_token.toString())
        : this.isSeller(data.access_token.toString());
      },
      error => {
        this.errorWarning(error);
      }
    );
  }

  isSeller(item: any) {
    this.tokenService.saveToken(item);
    let httpOptionsModulo = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + item
      })
    };
    this.getIsSeller(httpOptionsModulo).subscribe((data) => {
      localStorage.removeItem('authSeller');
      localStorage.setItem('authSeller', data.sellerCode);
    })
  }

  getIsSeller(item: any) {
    return this.apiService.getIsSeller(item);
  }

  public async getMfa(username: string, password: any, tenant: string, mfa: any) {
    await fetch(this.baseApiUrl + 'authorization/v2/mop-user-token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body: new URLSearchParams({
        'username': username,
        'password': password,
        'tenant': tenant.toLowerCase(),
        'mfa_totvs': mfa,
      })
      .toString()
    })
    .then(response => response.json())
    .then(token => {
      if (token.access_token != undefined) {
        this.tokenService.saveTokenV2(token.access_token);
        let decode: any = jwtDecode(token.access_token);
        this.tokenService.saveComponentsAccess(decode.components);
        this.validateUserHasAuthorization();
        this.router.navigate(['/modulo']);
      } else {
        throw new Error(token[0].message);
      }
    })
    .catch(err => {
      this.errorWarning(err);
    })
  }

  public getTokenV2(item: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'authorization/v2/mop-app-token', {token: item}, this.httpOptionsV2)
  }

  public errorWarning(item: any) {
    if (item == 'Error: Invalid username/password.') {
      this.poNotification.error('Usuário e/ou senha inválido');
    }
    else if (item == 'not found.') {
      this.poNotification.error('Usuário, senha e/ou ambiente inválido');
    }
    else {
      this.poNotification.error(item);
    }
  }

  public validateUserHasAuthorization(): boolean {
    var token = this.tokenService.getTokenV2();

    if (!token) {
      this.router.navigate(['/login']);
      return false;
    }

    if (this.tokenService.isNotExpiredToken(token)) {
      return true;
    } else {
      this.tokenService.signOut();
    }

    return false;
  }
}

